import { hasSpellCheckErrors, getErrorCounts } from '../utils';
import { createFixSpellingImage } from './createFixSpellingImage';

/**
 * Render the fix spelling custom control
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} left
 * @param {number} top
 * @param {object} styleOverride
 * @param {fabric.Object} fabricObject
 */
export function renderFixSpellingControl(
  ctx,
  left,
  top,
  styleOverride,
  fabricObject
) {
  if (!hasSpellCheckErrors(fabricObject)) {
    return;
  }

  const counts = getErrorCounts(fabricObject);

  ctx.save();
  ctx.translate(left, top);

  // Create dynamic button with error count
  const buttonImage = createFixSpellingImage(counts.total);

  // Draw the button
  ctx.drawImage(
    buttonImage,
    -this.sizeX / 2,
    -this.sizeY / 2,
    this.sizeX,
    this.sizeY
  );

  ctx.restore();
}
